export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_00.2a96d325.jpg";